<div class="event-dialog-wrapper">
  <div class="text-center mb-1">
    <mat-button-toggle-group appearance="legacy" name="fontStyle" aria-label="Font Style" [(value)]="view">
      @if (data.contentID || data.contentID != 'null') {
        <mat-button-toggle value="content">{{ 'Global.Content' | translate }}</mat-button-toggle>
      }
      <mat-button-toggle value="todoDetails">{{ 'Global.Details' | translate }}</mat-button-toggle>
      @if (!appNameIsDemo) {
        <mat-button-toggle value="members">{{ 'Global.Members' | translate }}</mat-button-toggle>
      }
    </mat-button-toggle-group>
  </div>

  @if (data.contentID || data.contentID != 'null') {
    <div class="content-wrapper">
      @if (view == 'content') {
        <div style="display: flex; justify-content: space-between">
          <div id="dummy"></div>
          <button mat-icon-button (click)="goToThePage()">
            <mat-icon>open_in_new</mat-icon>
          </button>
        </div>
      }
      @if (view == 'content') {
        <app-content [readMode]="'true'" [contentID]="contentID" [dialogData]="data.content" [from]="'pop-content'"></app-content>
      }
    </div>
  }

  @if (view == 'todoDetails') {
    <div class="p-1 m-0">
      <form name="eventForm" [formGroup]="eventForm" class="event-form flex-grow-item">
        <div class="flex-row flex-wrap responsive-flex-container">
          <div class="flex-basis-100">
            <mat-form-field class="full-width" appearance="fill">
              <mat-label>{{ 'Courses.Event.Title' | translate }}</mat-label>
              <input matInput name="name" formControlName="name" autocomplete="off" />
            </mat-form-field>
          </div>
          <div class="flex-row flex-gap flex-basis-100 responsive-flex-container">
            <mat-form-field class="flex-grow-item" appearance="fill">
              <mat-label>{{ 'Courses.Event.StartDate' | translate }}</mat-label>
              <input matInput [matDatepicker]="startDateDP" name="startDate" formControlName="start" />
              <mat-datepicker-toggle matSuffix [for]="startDateDP"></mat-datepicker-toggle>
              <mat-datepicker #startDateDP></mat-datepicker>
            </mat-form-field>
            @if (eventForm.value.selectedFreq != 'Unrepeated') {
              <mat-form-field appearance="fill" class="flex-grow-item">
                <mat-label>{{ 'Courses.Event.EndDate' | translate }}</mat-label>
                <input matInput [matDatepicker]="endDateDP" name="endDate" formControlName="end" />
                @if (maxDayIsReached) {
                  <mat-hint>{{ 'Calendar.MaxPeriodHint' | translate }}</mat-hint>
                }
                <mat-datepicker-toggle matSuffix [for]="endDateDP"></mat-datepicker-toggle>
                <mat-datepicker #endDateDP></mat-datepicker>
              </mat-form-field>
            }
          </div>
          <div class="flex-row flex-gap flex-basis-100 responsive-flex-container">
            <mat-form-field appearance="fill" class="flex-grow-item">
              <mat-label>{{ 'Courses.Event.StartTime' | translate }}</mat-label>
              <input matInput type="time" name="name" formControlName="startTime" placeholder="time" />
            </mat-form-field>
            <mat-form-field appearance="fill" class="flex-grow-item">
              <mat-label>{{ 'Courses.Event.EndTime' | translate }}</mat-label>
              <input matInput type="time" name="name" formControlName="endTime" placeholder="time" />
            </mat-form-field>
          </div>
          @if (action != 'edit') {
            <div class="flex-row flex-gap flex-basis-100 responsive-flex-container">
              <mat-form-field appearance="fill" class="flex-grow-item">
                <mat-label>{{ 'Courses.Event.Frequency' | translate }}</mat-label>
                <mat-select placeholder="Fréquence" formControlName="selectedFreq">
                  @for (type of freq; track type) {
                    <mat-option [value]="type.value">
                      {{ type.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (frequency != 'Unrepeated' && action != 'edit') {
                <div class="inline-form-field select-interval" class="flex-grow-item">
                  <span>{{ frequencySentence }}</span>
                  <mat-form-field appearance="fill">
                    <mat-label>{{ 'Calendar.Interval' | translate }}</mat-label>
                    <input matInput type="number" formControlName="interval" min="1" max="999" />
                  </mat-form-field>
                </div>
              }
            </div>
          }
          @if (frequency == 'Weekly' && action != 'edit') {
            <div class="flex-row flex-basis-100">
              <mat-form-field appearance="fill" class="flex-grow-item">
                <mat-label>{{ 'Calendar.WeekDay' | translate }}</mat-label>
                <mat-select formControlName="weekDays" multiple>
                  @for (weekDay of weekDays; track weekDay) {
                    <mat-option [value]="weekDay.value">{{ weekDay.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @if (frequency == 'Monthly' && action != 'edit') {
            <div class="flex-row flex-basis-100 mb-1">
              <label>{{ 'Calendar.SelectionType' | translate }}:</label>
              <mat-radio-group formControlName="monthlySelectionType">
                <mat-radio-button class="ml-1" value="simple">{{ 'Calendar.Simple' | translate }}</mat-radio-button>
                <mat-radio-button class="ml-1" value="advanced">{{ 'Calendar.Advanced' | translate }}</mat-radio-button>
              </mat-radio-group>
            </div>
          }
          @if (frequency == 'Monthly' && monthlySelectionType == 'advanced') {
            <div class="inline-form-field monthly-advance-selection">
              <mat-form-field appearance="fill">
                <mat-label>{{ 'Calendar.WeekDay' | translate }}</mat-label>
                <mat-select formControlName="weekDays" multiple>
                  @for (weekDay of weekDays; track weekDay) {
                    <mat-option [value]="weekDay.value">{{ weekDay.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <span>{{ 'Calendar.OfThe' | translate }}</span>
              <mat-form-field appearance="fill">
                <mat-label>{{ 'Calendar.WeeksOfMonth' | translate }}</mat-label>
                <mat-select formControlName="weeksOfMonth" multiple>
                  @for (weekOfMonth of weeksOfMonth; track weekOfMonth) {
                    <mat-option [value]="weekOfMonth.value">{{ weekOfMonth.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <span>{{ 'Calendar.Week' | translate }}</span>
            </div>
          }
          @if (frequency == 'Monthly' && monthlySelectionType == 'simple') {
            <div class="inline-form-field monthly-advance-selection day-of-month">
              <span>{{ 'Calendar.Every' | translate }}</span>
              <mat-form-field appearance="fill">
                <mat-label>{{ 'Calendar.DayOfTheMonth' | translate }}</mat-label>
                <input matInput type="number" min="1" max="31" formControlName="dayOfMonth" />
              </mat-form-field>
              <span>{{ 'Calendar.OfTheMonth' | translate }}</span>
            </div>
          }
          <div class="flex-column flex-basis-100">
            <mat-form-field appearance="fill" class="">
              <mat-label>{{ 'Courses.Event.Notes' | translate }}</mat-label>
              <textarea matInput formControlName="notes" max-rows="4"></textarea>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
  }

  @if (view == 'members') {
    <app-share-menu [data]="shareMenuData" [canEdit]="canEdit"></app-share-menu>
  }

  @if (canEdit && (view == 'todoDetails' || view == 'members')) {
    <div mat-dialog-actions class="flex-row space-between align-items-center m-0 p-1 with-delete-all-occurences">
      @if (action === 'edit') {
        <button mat-flat-button color="accent" (click)="deleteEvent()" aria-label="Delete" [matTooltip]="'Global.Delete' | translate">
          {{ 'Global.Delete' | translate }}
        </button>
      }
      @if (action === 'edit') {
        <button mat-flat-button color="accent" (click)="deleteAllOccurrencesOfEvent()" aria-label="Delete" [matTooltip]="'Global.Delete' | translate">
          {{ 'Global.DeleteAllOccurrencesOfEvent' | translate }}
        </button>
      }
      @if (eventForm) {
        <button mat-flat-button color="primary" (click)="saveEvent()" aria-label="SAVE" [disabled]="!formDatesAreValid()">
          {{ 'Global.Save' | translate }}
        </button>
      }
    </div>
  }
</div>
